import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface PageHeaderSkeletonProps {
  withSubtitle?: boolean;
  actions?: number;
  className?: string;
}

export function PageHeaderSkeleton({
  withSubtitle = true,
  actions = 1,
  className,
}: PageHeaderSkeletonProps) {
  return (
    <div
      className={cn(
        "flex items-start justify-between gap-4 w-full",
        className,
      )}
    >
      <div className="flex-1 min-w-0 space-y-2">
        <Skeleton className="h-6 w-48" />
        {withSubtitle && <Skeleton className="h-3 w-72 max-w-full" />}
      </div>
      {actions > 0 && (
        <div className="flex gap-2 flex-shrink-0">
          {Array.from({ length: actions }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-24 rounded-md" />
          ))}
        </div>
      )}
    </div>
  );
}
